module.exports = __webpack_public_path__ + "img/songs-start-here.87ec1693.svg";